import * as THREE from 'three';

const raycaster = new THREE.Raycaster();
const plane = new THREE.Plane(new THREE.Vector3(0, 0, 1));
const planeIntersectPoint = new THREE.Vector3();

export function calculateMouseInfluence(
  mousePosition: THREE.Vector2,
  starPosition: THREE.Vector3,
  camera: THREE.Camera
) {
  const mouse = new THREE.Vector2(
    (mousePosition.x * 2) - 1,
    -(mousePosition.y * 2) + 1
  );

  raycaster.setFromCamera(mouse, camera);
  raycaster.ray.intersectPlane(plane, planeIntersectPoint);

  const blackHoleCenter = new THREE.Vector3(
    planeIntersectPoint.x,
    planeIntersectPoint.y,
    0
  );

  const distanceToBlackHole = starPosition.distanceTo(blackHoleCenter);
  const influenceRadius = 8;
  const coreRadius = 0.5;
  const maxDisplacement = 2;

  const influence = distanceToBlackHole < influenceRadius
    ? distanceToBlackHole < coreRadius
      ? 1
      : Math.pow(1 - (distanceToBlackHole - coreRadius) / (influenceRadius - coreRadius), 2)
    : 0;

  const displacement = new THREE.Vector3();
  
  if (influence > 0) {
    displacement.subVectors(starPosition, blackHoleCenter).normalize();
    const angle = Math.atan2(displacement.z, displacement.x);
    const spiralFactor = 0.5;
    
    displacement.x = Math.cos(angle + influence * spiralFactor) * influence;
    displacement.z = Math.sin(angle + influence * spiralFactor) * influence;
    displacement.y *= 0.3;
    displacement.multiplyScalar(maxDisplacement * influence);
  }

  return { influence, displacement };
}